var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.578 28.835C27.052 27.015 31 21.852 31 15.767 31 8.164 24.836 2 17.233 2c-2.022 0-3.943.436-5.672 1.22C5.499 4.702 1 10.171 1 16.691c0 7.66 6.21 13.87 13.87 13.87 2.433 0 4.72-.627 6.708-1.727zM7.044 6.508a13.717 13.717 0 0 0-3.578 9.26c0 7.198 5.524 13.106 12.565 13.715-.382.034-.769.051-1.16.051-7.093 0-12.843-5.75-12.843-12.842A12.82 12.82 0 0 1 7.044 6.508zm5.668 13.985c1.952 1.723 5.24 2.569 7.398 1.233 2.876-3.596 1.233-8.014-.925-10.068-2.158-2.055-5.855-1.64-7.192 0-2.26 2.774-1.952 6.478.72 8.835z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLn);
export default __webpack_public_path__ + "static/media/LN.7ae4bd1da758122a5c06876d68c854d1.svg";
export { ForwardRef as ReactComponent };